import * as Styled from './Label.styles';

const Label = ({ children, ...props }) => {
  return (
    <Styled.Label {...props} className="glass-border">
      <span>{children}</span>
    </Styled.Label>
  );
};

export default Label;
